export default __webpack_public_path__ + "static/flag-be-ab296129775928eb7de8a2f9a2901056.svg";